module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"structureTitle":"Dashboard","structureSubTitle":"Select a sensor to view the data detected in the last 24h."},"it":{"structureTitle":"Dashboard","structureSubTitle":"Seleziona un sensore di cui visualizzare i dati rilevati nelle ultime 24h."}}')
  delete Component.options._Ctor
}
